import {createRouter,useRoute,createWebHistory,createWebHashHistory} from 'vue-router'
// import RouteConfig from './config'
import store from '@/store'
// import OverView from '../views/header/OverView.vue'
declare global {
  interface Window {
  _hmt?: any[][]
  }
}
const route = useRoute()
const router = createRouter({
    history:createWebHistory(),
    routes:[
        // redirect:'/'
        {
            path:'/#',
            name:'index',
            // meta:{title:'工程中心'},
            component:()=>import('../views/Index.vue'),
            children:[
                {
                    path:'/',
                    meta:{title:'首页'},
                    component:()=>import('/src/views/header/MainPage.vue')
                },  
                {
                    path:'/overview/about',
                    meta:{title:'基金简介'},
                    component:()=>import('/src/views/OverView/about.vue')
                },
                {
                    path:'/overview/rule',
                    meta:{title:'基金章程'},
                    component:()=>import('/src/views/OverView/rule.vue')
                },
                {
                    path:'/overview/org',
                    meta:{title:'组织结构'},
                    component:()=>import('/src/views/OverView/org.vue')
                },
                {
                    path:'/mien/about',
                    meta:{title:'院士风采'},
                    component:()=>import('/src/views/mien/mien.vue')
                },
                {
                    path:'/mien/win',
                    meta:{title:'成功之路'},
                    component:()=>import('/src/views/mien/win.vue')
                },
                {
                    path:'/awards/about',
                    meta:{title:'“李小文”奖介绍'},
                    component:()=>import('/src/views/awards/about.vue')
                },
                {
                    path:'/awards/introduce',
                    meta:{title:'奖励办法'},
                    component:()=>import('/src/views/awards/introduce.vue')
                },
                {
                    path:'/awards/prizewinner',
                    meta:{title:'获奖人名单'},
                    component:()=>import('/src/views/awards/prizewinner.vue')
                },
                {
                    path:'/news',
                    meta:{title:'新闻动态'},
                    component:()=>import('/src/views/news/news.vue')
                },
                {
                    path:'/news/:newsid',
                    meta:{title:'新闻动态'},
                    component:()=>import('/src/views/news/awards_2017.vue')
                },
                {
                    path:'/news/notice',
                    meta:{title:'通知公告'},
                    component:()=>import('/src/views/news/notice.vue')
                },
                {
                    path:'/registration',
                    meta:{title:'用户注册'},
                    component:()=>import('/src/views/registration/registration.vue')
                },
            ]
        },
    ]
})

router.afterEach((to) => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }
})

// router.beforeEach((to,from,next)=>{
//     const hasRoutes = store.state.hasRoutes
//     if(!store.state.hasRoutes){
//         RouteConfig.forEach(item=>{
//             router.addRoute('index',item)
//         })
//         store.commit('changeHasRoutes',true)
//         next({path:to.fullPath,replace:true})
//     }else{
//         next()
//     }
    
// })

export default router
